<template>
    <div class="news-container">
        <div class="newsCenter--banner">
            <img src="https://resource.rcclchina.com.cn/newsCenter/newscenter.jpg">
            <div class="imperial--intro">
                <h3 class="intro--Title">皇家新闻中心</h3>
                <p>汇集最新皇家加勒比游轮资讯，了解掌握皇家游轮相关动态，让您的旅途更加精彩！</p>
            </div>
            <div class="bg-shadow"></div>
        </div>
        <div class="timeline">
            <div class="timeline--title">
                <div class="chronicleOfEvent" v-bind:class="{tabActive: NewsType === 1}" @click="handleChangeTab(1)">大事记</div>
                <div class="acitivityCenter" v-bind:class="{tabActive: NewsType === 2}" @click="handleChangeTab(2)">重要公告
                    <div v-if="activeCenterNewsCount > 0" class="quantity--prompt">
                        <img src="https://resource.rcclchina.com.cn/newsCenter/img/quantityPrompt2.png">
                        <span class="num">{{activeCenterNewsCount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="readMore--container">
            <!--阅读详情-->
            <div v-for="item in newsList" :key="item.id" class="readMore--content">
                <div class="double--ticket--content">
                    <div class="ticket--img">
                        <img :src="item.image">
                    </div>
                    <div class="ticket--txt">
                        <div class="txt--title">{{item.title}}</div>
                        <div class="txt--time">{{item.createTime}}</div>
                        <div class="txt--intro">{{interceptChar(item.newsSummary, 176)}}</div>
                    </div>
                    <div class="ticket--detailBtn"><router-link :to="`/Rccl.CustomPage/RcclNews/Detail/${item.id}.html`">阅读详情&gt;</router-link></div>
                </div>
            </div>
        </div>

        <div class="pagination-container">
            <div class="row">
                <pagination
                    :size="pageSize"
                    :current="pageIndex"
                    :total="total"
                    :pageGroup="7"
                    placement="right"
                    @on-change="handleChangePage"
                ></pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import Pagination from '@/components/Review/Pagination'
    import { interceptChar } from '@/utilities/tools'

    export default {
        name: 'RcclNewsIndex',
        components: {
            Pagination,
        },
        data () {
            return {
                newsList: [],
                pageIndex: 1,
                pageSize: 5,
                total: 0,
                NewsType: 1, // 1、大事记；2、重要公告
                activeCenterNewsCount: 0,
            }
        },
        beforeMount () {
            this.initPage()
        },
        methods: {
            async initPage () {
                const data = await this.getNewsList()

                this.newsList = data.rcclNews
                this.total = data.rcclNewsCount
                this.activeCenterNewsCount = data.activeCenterNewsCount
            },
            interceptChar (str, num) {
                if(str) {
                    return interceptChar(str, num)
                }
                return '';
            },
            async handleChangePage (page) {
                this.pageIndex = page
                this.initPage()
            },
            async handleChangeTab (type) {
                this.NewsType = type
                this.pageIndex = 1
                this.initPage()
            },
            async getNewsList () {
                this.$loading.show()
                const {success, data, errMsg} = await api.page.getNews({
                    offset: (this.pageIndex - 1) * this.pageSize,
                    limit: this.pageSize,
                    NewsType: this.NewsType,
                })
                this.$loading.hide()
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
        },
    }
</script>

<style lang="less" scoped>
    .newsCenter--banner{
        position: relative;
        width:100%;
        overflow: hidden;
        img{
            width:100%;
        }
        .imperial--intro{
            position: absolute;
            top:55px;
            width: 100%;
            text-align: center;
            color: #fff;
            z-index:1;
        }
        .bg-shadow{
            position:absolute;
            top:0;
            width:100%;
            height:100%;
            background:rgba(0,0,0,.2);
            filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#33ffffff,endColorstr=#33ffffff);
        }
    }
    .timeline{
        width:100%;
        height:100px;
        background: #f0f0f0;
        padding-top: 19px;
        .timeline--title{
            width:320px;
            margin:0 auto;
            height: 62px;
        }
    }
    .timeline--title .chronicleOfEvent,.timeline--title .acitivityCenter{
        float: left;
        text-align: center;
        width:50%;
        height: 62px;
        line-height: 62px;
        cursor: pointer;
    }
    .timeline--title .chronicleOfEvent{
        background: #fff;
        color: #999999;
        font-size: 18px;
    }
    .timeline--title .acitivityCenter{
        background: #fff;
        position: relative;
        color: #999999;
        font-size: 18px;
        .quantity--prompt{
            position: absolute;
            top:-30px;
            left:70px;
            .num{
                position: absolute;
                top:0;
                left:5px;
                color: #fff;
                font-size: 12px;
            }
        }
    }
    .timeline--title .tabActive {
        background:#172566;
        color:#fff;
    }
    .readMore--container{
        background: #f0f0f0;
        padding-bottom: 50px;
    }
    .readMore--content{
        width:100%;
        height:214px;
        background: #f0f0f0;
    }
    .readMore--margin{
        margin-top: 10px;
    }
    .readMore--content .double--ticket--content{
        width:1142px;
        margin: 0 auto;
        height: 214px;
        background: #fff;
        padding: 25px;
    }
    .double--ticket--content .ticket--img,.double--ticket--content .ticket--txt,
    .double--ticket--content .ticket--detailBtn{
        float: left;
    }
    .double--ticket--content .ticket--img{
        width:248px;
        height:162px;
        margin-right: 20px;
    }
    .double--ticket--content .ticket--img img{
        width:245px;
    }
    .double--ticket--content .ticket--txt{
        width:650px;
        margin: 0 auto;
    }
    .ticket--txt .txt--title{
        width:100%;
        height:32px;
        font-size: 14px;
        font-weight: 600;
        line-height: 32px;
    }
    .ticket--txt .txt--time{
        width:100%;
        height:32px;
        overflow: hidden;
        font-size: 12px;
        color: #999999;
        font-weight: 600;
        line-height: 32px;
        border-bottom: 1px dotted #e5e5e5;
    }
    .double--ticket--content .ticket--detailBtn{
        width:202px;
        height:162px;
    }
    .ticket--txt .txt--intro{
        font-size: 12px;
        margin-top: 20px;
        line-height: 22px;
    }
    .double--ticket--content .ticket--detailBtn{
        width:108px;
        height:42px;
        border: 1px solid #e5e5e5;
        text-align: center;
        line-height: 42px;
        cursor: pointer;
        margin: 62px 0 0 45px;
    }
    .readMore--content:hover {
        .ticket--txt .txt--title {
            color: #051854;
        }
        .ticket--detailBtn{
            background-color: #fbc300;
            a {
                color: #333;
            }
            .txt--title {
                color: #051854
            }
        }
    }
    .double--ticket--content .ticket--detailBtn a{
        display:inline-block;
        width:100%;
        color: #1174b8;
        font-size: 12px;
        font-weight: 500;
    }
    .pagination-container {
        background-color: #f0f0f0;
        padding-bottom: 50px;
        .row{
            width: 1142px;
            margin: 0 auto;
        }
    }
</style>
